import React from 'react';
import {
  AreaChart, Area, BarChart, Bar, LineChart, Line, ComposedChart,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  Cell, ReferenceLine, ReferenceArea, Legend
} from "recharts";
import {
  RouteIcon, TrendingUp, Users, Activity, Crosshair, Sparkles,
  Trophy, ClipboardList, NotebookPen, Plus, Pencil, Trash2,
  ChevronDown, ChevronUp, Search, ArrowUpRight, ArrowDownRight,
  Download, Calendar, Clock, CheckCircle2, XCircle, AlertTriangle,
  Info, Zap, Brain, BarChart3, X, UserCheck, Building2,
  HeartHandshake, CalendarDays, CalendarCheck, Stethoscope,
  FlaskConical, Headphones, Receipt, Smartphone, Globe,
  HeartPulse, MessageSquare, ShoppingCart,
  CircleAlert, Lightbulb, TrendingDown, ScanSearch, Filter,
  Bell, Send, PanelLeftClose, PanelLeft, Archive, Link as LinkIcon, ExternalLink,
  History, Heart, MessageCircle, Share2, Upload, MapPin,
  ThumbsUp, ThumbsDown, EyeOff, Eye, Phone, Mail
} from "lucide-react";
import * as S from './_shared';
export default function EvaView({ ctx }) {
  const {
    ACOES_INIT,
    AcaoCard,
    AcaoDetalhe,
    AcaoModal,
    C,
    CES_COLS,
    CES_ETAPAS_NAMES,
    CES_TREND,
    CIDADES_COBERTURA,
    COOP_PLANOS_MOCK,
    CSAT_COLS,
    CSAT_ETAPAS_NAMES,
    CSAT_TREND,
    Card,
    DRIVERS_CANONICOS,
    DRIVER_TO_PILLAR,
    DistBar,
    ESCALA,
    ETAPA_DRIVER_AFFINITY,
    ETAPA_HIST,
    EtCard,
    EvaChat,
    EvaChatHistory,
    EvaInsights,
    F,
    HIST_ACOES_POR_ETAPA,
    JCFG,
    JICONS,
    LOGO,
    MESES_HIST,
    META_NPS,
    MUDANCAS_DESDE_ULTIMA_VISITA,
    MiniSparkline,
    NPSAnchor,
    PC,
    PDFExportModal,
    PER,
    PER_DEFAULT_LABELS,
    PER_OPTIONS,
    PILLAR_COLORS,
    PeriodPill,
    PeriodPillBig,
    SC,
    SHORT,
    SUCESSO_BADGES,
    SUCESSO_LEVELS,
    SYS_NPS,
    Section,
    TREND_BY_AGRUP,
    TT,
    Tag,
    ULTIMA_VISITA,
    UNIMED,
    VERBATINS_POR_ETAPA,
    Z_CX,
    Zonas,
    _META_CES_TR,
    _META_CSAT_TR,
    _META_NPS_TR,
    _SYS_CES_TR,
    _SYS_CSAT_TR,
    _SYS_NPS_TR,
    diasRest,
    etSt,
    exportPDF,
    fmtDt,
    getDriverInfo,
    getDriversForEtapa,
    getPilarOf,
    getSucessoStats,
    moe,
    pctChk,
    safeGanhoPp,
    tempoRelativo,
    todayStr
  } = S;
  const {
    DATA,
    SAUDACAO_EVA,
    acaoSel,
    acoes,
    adicionarComentario,
    agrupT,
    atualizarMensagensChatEva,
    bulkApplyEtapas,
    bulkApplyGerais,
    bulkOpen,
    bulkPct,
    busca,
    cidadesAtivas,
    compartilharPlano,
    concluirWizard,
    coopBusca,
    coopComentariosAbertos,
    coopCurtidas,
    coopDriverFilter,
    coopEtapaFilter,
    coopNovoComentario,
    coopPlanos,
    d,
    db,
    dd,
    de,
    delAcao,
    desocultarNotif,
    dj,
    driverSortMode,
    ds,
    editandoMeta,
    editandoMetaEt,
    etapaDriversFilter,
    etapaHistSel,
    etapaSel,
    evaChatAtivoId,
    evaChats,
    excluirChatEva,
    filtroCidadeAberto,
    filtroResp,
    filtroSt,
    gamificacaoOn,
    hiddenLines,
    historicoEvaVisivel,
    jorGraf,
    marcarComoLida,
    marcarTodasLidas,
    metas,
    metasCardOpen,
    metasEtapas,
    modal,
    mostrarOcultos,
    naoLidas,
    nenhumaCidade,
    notifModalFiltro,
    notifModalOpen,
    notifOpen,
    notifs,
    notifsOcultas,
    notifsVisiveis,
    novoChatEva,
    ocultarNotif,
    openPublishWizard,
    pB,
    pD,
    pE,
    pJ,
    pS,
    per,
    periodoCustom,
    periodoG,
    respDropOpen,
    segHistMode,
    segIndicador,
    selecionarChatEva,
    setAcaoSel,
    setAcoes,
    setAgrupT,
    setBulkApplyEtapas,
    setBulkApplyGerais,
    setBulkOpen,
    setBulkPct,
    setBusca,
    setCidadesAtivas,
    setConcluirWizard,
    setCoopBusca,
    setCoopComentariosAbertos,
    setCoopCurtidas,
    setCoopDriverFilter,
    setCoopEtapaFilter,
    setCoopNovoComentario,
    setCoopPlanos,
    setDriverSortMode,
    setEditandoMeta,
    setEditandoMetaEt,
    setEtapaDriversFilter,
    setEtapaHistSel,
    setEtapaSel,
    setEvaChatAtivoId,
    setEvaChats,
    setFiltroCidadeAberto,
    setFiltroResp,
    setFiltroSt,
    setGamificacaoOn,
    setHiddenLines,
    setHistoricoEvaVisivel,
    setMetaEtapa,
    setMetas,
    setMetasCardOpen,
    setMetasEtapas,
    setModal,
    setMostrarOcultos,
    setNotifFeedback,
    setNotifModalFiltro,
    setNotifModalOpen,
    setNotifOpen,
    setNotifs,
    setPB,
    setPD,
    setPE,
    setPJ,
    setPS,
    setPeriodoCustom,
    setPeriodoG,
    setPrefilledAcao,
    setRespDropOpen,
    setSegIndicador,
    setStDropOpen,
    setSucessoFiltroPeriodo,
    setSucessoModalOpen,
    setTab,
    setTipoBenefAberto,
    setTipoBeneficiario,
    setVerbatinsModal,
    stDropOpen,
    sucessoFiltroPeriodo,
    sucessoModalOpen,
    tab,
    tipoBenefAberto,
    tipoBeneficiario,
    todasCidades,
    toggleCidade,
    toggleComentarios,
    toggleCoopDriver,
    toggleCurtida,
    toggleLine,
    toggleSegHist
  } = ctx;
  return (()=>{
        const chatAtivo = evaChats.find(c => c.id === evaChatAtivoId) || evaChats[0];
        return <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:14}}>
          <EvaInsights insights={d.evaInsights} d={d} per={per}/>
          <Section title="Conversa com a Eva" pad={false}>
            <div style={{padding:"12px 16px",display:"flex",gap:12}}>
              {/* Sidebar de histórico estilo ChatGPT/Claude — colapsável */}
              {historicoEvaVisivel && <EvaChatHistory
                chats={evaChats}
                ativoId={evaChatAtivoId}
                onSelect={selecionarChatEva}
                onNew={novoChatEva}
                onDelete={excluirChatEva}
              />}
              {/* Coluna direita: header + chat */}
              <div style={{flex:1,minWidth:0,display:"flex",flexDirection:"column"}}>
                <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",background:C.g800,borderRadius:12,marginBottom:12}}>
                  {/* Botão toggle do histórico — estilo Claude */}
                  <button
                    onClick={()=>setHistoricoEvaVisivel(v=>!v)}
                    title={historicoEvaVisivel ? "Ocultar histórico" : "Mostrar histórico"}
                    style={{
                      display:"flex",alignItems:"center",justifyContent:"center",
                      width:32,height:32,borderRadius:8,
                      background:"rgba(255,255,255,.08)",
                      border:"1px solid rgba(255,255,255,.12)",
                      cursor:"pointer",transition:"all .15s",
                      flexShrink:0,fontFamily:"inherit",color:"#FFFFFF"
                    }}
                    onMouseEnter={e=>{e.currentTarget.style.background="rgba(255,255,255,.15)";}}
                    onMouseLeave={e=>{e.currentTarget.style.background="rgba(255,255,255,.08)";}}
                  >
                    {historicoEvaVisivel ? <PanelLeftClose size={16}/> : <PanelLeft size={16}/>}
                  </button>
                  <div style={{width:32,height:32,borderRadius:"50%",background:`linear-gradient(135deg,${C.g600},${C.p500})`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><Sparkles size={14} color="#fff"/></div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{color:"#FFFFFF",fontWeight:600,fontSize:13,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>Eva — Persona Sintética</div>
                    <div style={{color:"rgba(255,255,255,.4)",fontSize:10}}>Dados de {per.label}</div>
                  </div>
                </div>
                <EvaChat
                  key={chatAtivo ? chatAtivo.id : "empty"}
                  d={d}
                  periodo={periodoG}
                  mensagens={chatAtivo ? chatAtivo.mensagens : [SAUDACAO_EVA]}
                  onMensagensUpdate={atualizarMensagensChatEva}
                />
              </div>
            </div>
          </Section>
        </div>;
      })();
}
